import React from "react";
import "./VideoSection.css";

const VideoSection = ({ title, subtitle, videoSrc, placeholderImage }) => {
  return (
    <section className="video-section">
      <div className="video-container">
        <div className="video-content">
          <h2 className="video-title">
            <span>{title}</span>
            {subtitle && <span className="title-accent"> {subtitle}</span>}
          </h2>
          <p className="video-description">
            Experience our advanced capabilities in action through immersive
            video demonstrations.
          </p>
        </div>

        <div className="video-player">
          <div className="video-placeholder coming-soon">
            <div className="coming-soon-content">
              <div className="coming-soon-icon">
                <div className="pulse-ring"></div>
                <div className="pulse-ring"></div>
                <div className="pulse-ring"></div>
                <span>🚀</span>
              </div>
              <h3>Coming Soon</h3>
              <p>Interactive demonstration of our advanced capabilities</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
